module.exports = __webpack_public_path__ + "img/BPSYSCS4.f227609f.jpg";